import React, { useEffect } from 'react';
import { notification, Popconfirm } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { TooltipPlacement } from 'antd/lib/tooltip';
import clsx from 'clsx';
import styles from './PopConfirm.module.less';

type PopConfirmProps = {
  title: string;
  className?: string;
  tooltipPlacement?: TooltipPlacement;
  isLoading: boolean;
  icon?: IconProp;
  errorMessage: string;
  okText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};

const okTextDefault = 'Yes, I am sure';
const cancelTextDefault = 'No, keep it for now';

const PopConfirm: React.FC<PopConfirmProps> = ({
  title,
  isLoading,
  className,
  tooltipPlacement,
  icon,
  errorMessage,
  okText,
  cancelText,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (errorMessage) {
      notification.error({ message: errorMessage });
    }
  }, [errorMessage]);

  return (
    <Popconfirm
      title={title}
      okText={okText || okTextDefault}
      cancelText={cancelText || cancelTextDefault}
      placement={tooltipPlacement || 'bottom'}
      icon={null}
      onCancel={onCancel}
      onConfirm={onConfirm}
      disabled={isLoading}
    >
      {icon && (
        <FontAwesomeIcon icon={icon} className={clsx(styles.icon, { [styles.disabled]: isLoading }, className)} />
      )}
    </Popconfirm>
  );
};
export default PopConfirm;
